import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledPath = styled.path`
  fill: ${(p) => p.theme.colors.oceanBlue};
`
const TireIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 47.029 47.924">
    <g transform="translate(-2.56 -2)">
      <StyledPath d="M33.894 2H18.255C9.6 2 2.56 12.743 2.56 25.962S9.6 49.924 18.255 49.924h15.639c8.65 0 15.7-10.759 15.7-23.962S42.544 2 33.894 2zM18.255 3.661h9.9a17.884 17.884 0 0 0-6.07 6.574l-9.305 4.393-4.7-3.994c2.547-4.281 6.165-6.973 10.175-6.973zm.056 19.6l-7.236 4.385-6.758-4.08a30.448 30.448 0 0 1 2.94-11.406l4.848 4.1a.8.8 0 0 0 .535.2.943.943 0 0 0 .359-.08l7.852-3.714a32.508 32.508 0 0 0-2.54 10.6zm-14.066 2.2l6.39 3.882a.855.855 0 0 0 .871 0l6.709-4.074v.695A34.114 34.114 0 0 0 20.2 37.615l-5.08 3.954-8.91-4.425h-.1a32.748 32.748 0 0 1-1.873-11.182c0-.168.008-.336.008-.503zm14.01 22.8c-4.545 0-8.586-3.459-11.182-8.786l7.727 3.843a.9.9 0 0 0 .375.088.8.8 0 0 0 .511-.192l5.12-3.994a19.558 19.558 0 0 0 7.308 9.026zm15.639 0c-4.992 0-9.385-4.185-11.869-10.471a.8.8 0 0 0-.152-.375 32.748 32.748 0 0 1-1.989-11.454c0-12.3 6.286-22.3 14.01-22.3s14.018 10 14.018 22.3-6.286 22.301-14.018 22.301z" />
      <StyledPath
        d="M39.789 13.84c-4.449 0-7.939 6.39-7.939 14.5s3.49 14.5 7.939 14.5 7.987-6.39 7.987-14.5-3.53-14.5-7.987-14.5zm0 27.341c-3.395 0-6.222-5.879-6.222-12.836s2.867-12.836 6.262-12.836 6.23 5.879 6.23 12.836-2.867 12.836-6.27 12.836z"
        transform="translate(-5.895 -2.383)"
      />
    </g>
  </SvgIcon>
)

export default TireIcon
